import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/EventList.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/images/ladure_image.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
